import $ from 'jquery';


export default () => {
    $(window).on('load', () => {

        // Trova il primo elemento textarea del reCAPTCHA
        var $inputForLabel1 = $(".g-recaptcha-response");

        // Se esiste un unico textarea con l'ID "g-recaptcha-response-100000" nella pagina
        if ($inputForLabel1.length > 0) {
            // Controlla se esiste già una label con lo stesso ID
            $inputForLabel1.each((i, el) => {
                var $el = $(el);
                var id = $el.attr('id');
                if ($('label[for="' + id + '"]').length === 0) {
                    // Crea una nuova label con il testo "Captcha" e la classe "sr-only"
                    var $label1 = $("<label>").addClass("sr-only").text("Captcha");

                    // Imposta l'attributo "for" della label
                    $label1.attr("for", $el.attr("id"));

                    // Inserisci la label prima dell'elemento textarea del reCAPTCHA
                    $el.prev().before($label1);
                }
            })

        }
    });
};


// WEBPACK FOOTER //
// ./scripts/libs/recaptcha-accessibility.js